import { Button, ConfirmDialog } from '@planitgeo/treeplotter-ui-library';
import { useLocales } from 'locales';
import { ConfirmationConfig, ConfirmationType } from 'common/infrastructure/dialog/types';
import { getConfirmationData } from 'common/infrastructure/dialog/confirmationTypes';

type ModalHeaderDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSave: () => void;
  confirmationConfig: ConfirmationConfig | null;
  isSaving?: boolean;
};

export default function ModalHeaderDialog({
  open,
  onClose,
  onConfirm,
  onSave,
  confirmationConfig,
  isSaving = false,
}: ModalHeaderDialogProps) {
  const { translate } = useLocales();

  // Early return if confirmationConfig is falsy or shouldConfirm is false
  if (!confirmationConfig || !confirmationConfig.shouldConfirm) {
    return null;
  }

  const confirmationData = getConfirmationData(confirmationConfig.confirmationType);

  if (!confirmationData) {
    return null;
  }

  const isTabSwitch =
    confirmationConfig.confirmationType === ConfirmationType.UNSAVED_CHANGES_TAB_SWITCH;

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title={translate(confirmationData.titleKey)}
      message={translate(confirmationData.messageKey)}
      cancelLabel={translate('cancel')}
      action={
        isTabSwitch ? (
          <Button
            shape="pill"
            onClick={onSave}
            disabled={isSaving}
            data-testid="save_changes_dialog_save_button"
          >
            {translate('data.save')}
          </Button>
        ) : (
          <Button
            color="error"
            shape="pill"
            onClick={onConfirm}
            data-testid="ignore_changes_dialog_continue_button"
          >
            {translate('data.continue')}
          </Button>
        )
      }
    />
  );
}
